import { platformMap } from "../data/platforms";
import { formatRelativeTime } from "../lib/format";
import type { FavoriteItem, HistoryItem } from "../types";
import { Icon } from "./Icon";

interface LibraryPanelProps {
  open: boolean;
  tab: "favorites" | "history";
  favorites: FavoriteItem[];
  history: HistoryItem[];
  onClose: () => void;
  onChangeTab: (tab: "favorites" | "history") => void;
  onRemoveFavorite: (key: string) => void;
  onClearHistory: () => void;
}

export function LibraryPanel({
  open,
  tab,
  favorites,
  history,
  onClose,
  onChangeTab,
  onRemoveFavorite,
  onClearHistory,
}: LibraryPanelProps) {
  if (!open) return null;

  return (
    <>
      <button className="panel-scrim is-visible" aria-label="关闭个人内容" onClick={onClose} type="button" />
      <aside className="side-panel is-open" aria-label="收藏与浏览记录">
        <header className="panel-heading">
          <div>
            <span className="section-index">个人</span>
            <h2>我的内容</h2>
          </div>
          <button className="icon-button" aria-label="关闭" onClick={onClose} type="button"><Icon name="close" /></button>
        </header>
        <nav className="panel-tabs">
          <button className={tab === "favorites" ? "is-active" : ""} onClick={() => onChangeTab("favorites")} type="button">
            收藏 <span>{favorites.length}</span>
          </button>
          <button className={tab === "history" ? "is-active" : ""} onClick={() => onChangeTab("history")} type="button">
            浏览记录 <span>{history.length}</span>
          </button>
        </nav>

        <div className="panel-content">
          {tab === "favorites" ? (
            favorites.length ? (
              <ul className="library-list">
                {favorites.map((item) => (
                  <li key={item.key}>
                    <a href={item.url} rel="noreferrer" target="_blank">
                      <strong>{item.title}</strong>
                      <span>{platformMap.get(item.platformId)?.name || item.platformId} · {formatRelativeTime(item.createdAt)}</span>
                    </a>
                    <button aria-label={`删除收藏：${item.title}`} onClick={() => onRemoveFavorite(item.key)} type="button"><Icon name="trash" /></button>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="panel-empty"><Icon name="bookmark" /><strong>还没有收藏</strong><p>点击榜单条目右侧的收藏按钮即可保存。</p></div>
            )
          ) : history.length ? (
            <>
              <button className="clear-button" onClick={onClearHistory} type="button"><Icon name="trash" />清空浏览记录</button>
              <ul className="library-list history-list">
                {history.map((item) => (
                  <li key={`${item.key}-${item.viewedAt}`}>
                    <a href={item.url} rel="noreferrer" target="_blank">
                      <strong>{item.title}</strong>
                      <span>{platformMap.get(item.platformId)?.name || item.platformId} · {formatRelativeTime(item.viewedAt)}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <div className="panel-empty"><Icon name="clock" /><strong>还没有浏览记录</strong><p>打开榜单条目后会在这里保留记录。</p></div>
          )}
        </div>
      </aside>
    </>
  );
}
